import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public isloadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {}

  startLoading() {
    this.isloadingSubject.next(true);
  }

  stopLoading() {
    this.isloadingSubject.next(false);
  }
}
